import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createPurInwEntry = createAsyncThunk('createPurInwEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPI`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const createDirectPurInwEntry = createAsyncThunk('createDirectPurInwEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPIDirect`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchMemoNo = createAsyncThunk('fetchMemoNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPurInwardData = createAsyncThunk('fetchPurInwardData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPIlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deletePI = createAsyncThunk('deletePI', async (Ids) => {
    const { purId, clothId, pInfoId } = Ids;
    try {
        const response = await axios.get(`${baseUrl}?apicall=deletePI&purId=${purId}&clothId=${clothId}&pInfoId=${pInfoId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});




const cuttingSlice = createSlice({
    name: 'CuttingData',
    initialState: {
        isLoading: false,
        memo: null,
        piNo: null,
        deletePurInward: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMemoNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMemoNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.memo = action.payload;
        });
        builder.addCase(fetchMemoNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



    }
});

export default cuttingSlice.reducer;
